import { createAction, props } from '@ngrx/store';
// import { Ambulance } from 'src/models/module-wise/user/patient';

// TODO: Add Interface

export const paginateAmbulances = createAction(
  '[ AMBULANCE ] Paginating'
);

export const loadAmbulances = createAction(
  '[ AMBULANCE ] Load Ambulance',
  props<{ payload: any[], totalDocuments: number }>()
);

export const editAmbulance = createAction(
  '[ AMBULANCE ] Edit Ambulance',
  props<{ payload: any | { status: string, _id: string } }>()
);

export const removeAmbulances = createAction(
  '[ AMBULANCE ] Delete Ambulance',
  props<{ payload: string[] }>()
);

export const removeAllAmbulances = createAction(
  '[ AMBULANCE ] Remove All Ambulance'
);
